import {
  useAuditLogSearchApi,
  useAuditLogSearchCondition,
  useDownloadAuditLogsCsv
} from '@/common/api/modules/auditLog'
import { useFirstLoading } from '@/common/api/search'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import Area from '@/components/view/layouts/area/Area'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageListLoading from '@/components/view/molecules/loading/PageListLoading'
import PageListSearching from '@/components/view/molecules/loading/PageListSearching'
import NoResultGuidance from '@/components/view/molecules/search/NoResultGuidance'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import AuditLogListTable from '@/components/container/modules/admin/auditLog/table/AuditLogListTable'
import AuditLogSearchConditionField from '@/components/container/modules/admin/auditLog/table/AuditLogSearchConditionField'
import TitlePageInfo from '@/components/container/utils/pager/TitlePageInfo'

const AuditLogPage = () => {
  const [condition, setCondition, onUpdatePage] = useAuditLogSearchCondition()
  const { data, isLoading } = useAuditLogSearchApi(condition)
  const isFirstLoading = useFirstLoading(isLoading)

  const { trigger: downloadCsv, isMutating: isDownloading } = useDownloadAuditLogsCsv((blob) => {
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download = `監査ログ_${new Date().toISOString().slice(0, 10)}.csv`
    a.click()
  })

  return (
    <Main type={MainLayoutType.FULL}>
      <PageTitle
        title='監査ログ'
        description='全操作の履歴を記録・閲覧します。'
        behindNode={
          data && (
            <TitlePageInfo
              page={condition.page}
              perPage={condition.perPage}
              total={data.total}
              unit='件'
            />
          )
        }
        rightNode={
          <Button
            color={ButtonColor.SECONDARY}
            size='large'
            loading={isDownloading}
            onClick={() =>
              downloadCsv({
                ...(condition.action && { action: condition.action }),
                ...(condition.operatorName && { operator_name: condition.operatorName }),
                ...(condition.dateFrom && { date_from: condition.dateFrom }),
                ...(condition.dateTo && { date_to: condition.dateTo })
              })
            }
          >
            CSVダウンロード
          </Button>
        }
      />
      <Content>
        {isFirstLoading ? (
          <PageListLoading />
        ) : (
          <Area tableWrap noBorder>
            <AuditLogSearchConditionField condition={condition} setCondition={setCondition} />
            {isLoading ? (
              <PageListSearching />
            ) : data?.total ? (
              <AuditLogListTable
                logs={data.items}
                condition={condition}
                setCondition={setCondition}
                onUpdatePage={onUpdatePage}
                total={data.total}
              />
            ) : (
              <NoResultGuidance searched name='監査ログ' />
            )}
          </Area>
        )}
      </Content>
    </Main>
  )
}

export default AuditLogPage
